var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 18.2608L14.7826 39.311C16.4461 39.7593 18.1947 39.9999 19.9999 39.9999C31.0456 39.9999 39.9999 31.0456 39.9999 19.9999L13.0435 18.2608Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 19.9999L14.7825 0.688923C16.4461 0.240564 18.1947 -6.10352e-05 19.9999 -6.10352e-05C31.0456 -6.10352e-05 39.9999 8.95431 39.9999 19.9999H13.0435Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 29.2405 6.26727 37.016 14.7826 39.311V0.688965C6.26727 2.98396 0 10.7594 0 20Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenin);
export default __webpack_public_path__ + "static/media/benin.9dab6d3ce2cf110bb42fba887b2d9d65.svg";
export { ForwardRef as ReactComponent };